export enum PlayerSize {
  Fullscreen = 'FULLSCREEN',
  Window = 'WINDOW',
}
